import { P2Alert, P2TextDescription } from "react-bootstrap-common-script";
import { SectionCard } from "../../../components/card";

const PrivateSolicitorView = () => (
  <div className="d-flex justify-content-center">
    <SectionCard
      required={false}
      className="flex-fill"
      stepperItems={[]}
      titleChildren={<P2TextDescription title="Prepare for Completion" />}
      contentChildren={
        <div style={{paddingLeft: 16, paddingRight: 16}}>
          <P2Alert variant={"warning"} text={"Please contact your appointed lawyer to arrange your completion appointment. "} withBorder />
        </div>
      }
    />
  </div>
);

export default PrivateSolicitorView;
